import { buildUrl, joinPaths } from '@ascend-ops/domain';

let urlBuilder = buildUrl(
  process.env.PUBLIC_URL ?? import.meta.env.BASE_URL ?? '/',
);

export const setAppUrlRoot = (urlRoot: string) => {
  urlBuilder = buildUrl(urlRoot.replace(/\/\/*/g, '/'));
};

export const buildAppUrl = (
  subPath: string,
  options?: {
    urlRoot?: string;
  },
): string => {
  const { urlRoot } = options || {};
  const builder = urlRoot ? buildUrl(urlRoot) : urlBuilder;

  return builder(subPath);
};

export const getServerApiUrl = (urlPath = '') => {
  const isLocalEnv = import.meta.env.VITE_NODE_ENV === 'local';
  const endpoint = (import.meta.env.VITE_ASCEND_OPS_INTEGRATION_ENDPOINT ||
    '') as string;

  return isLocalEnv ? joinPaths(endpoint, urlPath) : urlPath;
};

export const getCookie = (name: string) => {
  const cookie: Record<string, string> = {};
  document.cookie.split(';').forEach(function (el) {
    const split = el.split('=');
    cookie[split[0].trim()] = split.slice(1).join('=');
  });
  return cookie[name];
};

export const OKTA_TENANT_STORAGE_KEY = 'oktaTenant';
export const AUTH_TENANT_INFO_STORAGE_KEY = 'authTenantInfo';
export const AUTH_TENANT_TYPE_PARAM_KEY = 'authTenantType';
export const AUTH_TENANT_CODE_PARAM_KEY = 'authTenantCode';
